/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import { CalloutContext, useOkapiKy } from '@folio/stripes/core';
import { FormattedMessage, useIntl } from 'react-intl';
import TemplateBuilder from '../TemplateBuilder';
import useTemplate from '../../../../hooks/useTemplate';

function EditTemplate(props) {
  const history = useHistory();
  const okapiKy = useOkapiKy();
  const context = useContext(CalloutContext);

  const { templateId } = useParams();
  const { templates, isLoading } = useTemplate(templateId);
  const { locale } = useIntl();

  const localizedName = templates?.name?.find(
    (field) => field?.locale === locale,
  )?.value;

  const initialValues = useMemo(
    () => ({
      templateInfo: {
        name: templates?.name,
        description: templates?.description,
        code: templates?.code,
        isDefault: templates?.isDefault,
        isLocked: templates?.isLocked,
        active: templates?.active,
      },
      templateFields: templates?.templateFields,
    }),
    [templateId, isLoading],
  );

  const onSubmit = (values) => {
    okapiKy
      .put(`inventory-templates/${templateId}`, {
        timeout: 30000,
        method: 'PUT',
        headers: {
          'content-Type': 'application/json',
          accept: 'text/plain',
        },
        json: {
          ...values.templateInfo,
          templateFields: values.templateFields,
        },
      })
      .json()
      .then(() => {
        const message = (
          <FormattedMessage
            id="ui-plugin-inventory-templates.editTemplate.callout.updated"
            defaultMessage="Template updated successfully"
          />
        );
        history.push(`${props.basePath}/${templateId}/view`);
        context.sendCallout({ message });
      })
      .catch(async (err) => {
        const res = err.response;
        const text = await res.text();
        console.log('error: ', text);
        context.sendCallout({ message: text, type: 'error' });
      });
  };

  return (
    <TemplateBuilder
      initialValues={initialValues}
      onSubmit={onSubmit}
      paneTitle={
        <FormattedMessage
          id="ui-plugin-inventory-templates.editTemplate.pane.paneTitle"
          values={{ template: localizedName }}
          defaultMessage="Edit {template} template"
        />
      }
      isLoading={isLoading}
    />
  );
}

EditTemplate.propTypes = {
  basePath: PropTypes.string,
};

export default EditTemplate;
